import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-grape/15 bg-white/70" data-id="element-69" data-mp="3gfiv8kpoaff6">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px"
    }} data-id="element-70" data-mp="3gh3rqfvjs8fo">
        <p className="font-display text-xl font-black text-plum" data-id="element-71" data-mp="36pft9v0kpr4p">
          THE 360° INJURY REHAB SYSTEM<span className="align-super text-xs" data-id="element-72" data-mp="36n3gdw9oa6yi">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-plum/65" data-id="element-73" data-mp="3ufjuxwu7bgt2">
          The visual method to manage injury rehabilitation from absolute zero: joint mechanics,
          complete assessment protocols, progressive exercise frameworks and return-to-sport
          criteria in 30 days.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-plum/75" data-id="element-74" data-mp="3qfjgwdb0l7mj">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-75" data-mp="2a1jk3b7gty3i">
            <MailIcon className="h-4 w-4 text-grape" data-id="element-76" data-mp="3labqfslx60os" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-77" data-mp="3gbqz6ionarch">
            <InstagramIcon className="h-4 w-4 text-grape" data-id="element-78" data-mp="3v916rgy63d2x" /> @sigmasmartoficial
          </a>
          
        </div>

        <p className="mt-4 font-display text-base font-semibold italic text-grape" data-id="element-79" data-mp="3qazq12o7rpum">
          🏥 “Your first protocol starts today.”
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-plum/45" data-id="element-80" data-mp="32w2ztma9cas">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-81" data-mp="hrs8biwygb7p">
            Terms & Conditions
          </a>
          <span data-id="element-82" data-mp="cvtp09qhhje5">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-83" data-mp="qthzqoqu7a5h">
            Privacy Policy
          </a>
          <span data-id="element-84" data-mp="mspq3ue1z38o">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-85" data-mp="mthlp57nh0yy">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-plum/40" data-id="element-86" data-mp="yu7hkrnonpy7">
          © 2026 THE 360° INJURY REHAB SYSTEM™ — SIGMA SMART™ — All rights reserved. Reproduction
          and redistribution prohibited without express authorization.
        </p>
      </div>
    </footer>;
}